import { render, staticRenderFns } from "./productionSettle.vue?vue&type=template&id=05c447d5&scoped=true"
import script from "./productionSettle.vue?vue&type=script&lang=js"
export * from "./productionSettle.vue?vue&type=script&lang=js"
import style0 from "./productionSettle.vue?vue&type=style&index=0&id=05c447d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c447d5",
  null
  
)

export default component.exports